import { Component, OnInit } from '@angular/core';
import { Department } from '../department';
import { DepartmentService } from '../department.service';
//import { VendorService } from '../../vendor/vendor.service';
import { Location } from '@angular/common';
import { ToastrManager } from 'ng6-toastr-notifications';
import { UtilityService } from  '../../utility.service';
import { ActivatedRoute, Params } from '@angular/router';
import { Router} from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../auth.service';

@Component({
  selector: 'app-add-department',
  templateUrl: './add-department.component.html',
  styleUrls: ['./add-department.component.css']
})
export class AddDepartmentComponent implements OnInit {


  department = new Department();
  
  submitted = false;
//	vendors: any[];
    departments: any [];
 //   requester: any [];
  
    private newAttribute: any = {};
    departmentForm: FormGroup;
    public isupdate = false;
    public FormName = "Add New Department";

  constructor(
    private departmentService: DepartmentService, 
   // private vendorService : VendorService,
    private location: Location, 
    private formBuilder: FormBuilder, 
    private util:UtilityService, 
    public toastr: ToastrManager, 
    private router: Router,
    private route: ActivatedRoute,
    private auth: AuthService
    ) { }

    newPo(): void {
      this.submitted = false;
      this.department = new Department();
    }

    onSubmit() {
      this.submitted = true;
      // stop here if form is invalid
      if (this.departmentForm.invalid) {
          return this.util.showError("Please enter required fields.");		
      }
    else{
      if(this.isupdate){
        this.update();
      }
      else{
        this.addDepartment();
      }
    }
  }

  addDepartment() {
      //this.submitted = true;
      this.save();
    }
	
   
  private save(): void {	  

  
   this.department.createdby = this.auth.currentUserValue.userid
   
	  this.departmentService.addDepartment(this.department).subscribe((data :any) => {
		  console.log(data);
		  this.util.showSuccess("Department added successfully.")
		});
		this.router.navigate(['/department-list']);
          //for Redirecting to the list view     
  }
  goBack(): void {
    this.location.back();
  }

  update(): void {
    this.submitted = true;
    this.departmentService.updateDepartment(this.department)
        .subscribe(() => this.util.showSuccess("Department update successfully."));
        this.router.navigate(['/department-list']);
  }
  
  ngOnInit() {
	this.department.active = 1;
	//	this.getrequester();
    if(this.route.snapshot.paramMap.get('deptid') != null)
    {
      const deptid = +this.route.snapshot.paramMap.get('deptid');
       if(deptid > 0)
       {
         this.getDepartment(deptid);
       }
       this.isupdate = true;
       this.FormName = "Update Department";				 
    }
    this.departmentForm = this.formBuilder.group({			
      deptname: [this.department.deptname,[Validators.required, Validators.required]],
      active: [this.department.active,[Validators.required, Validators.required]]
 //     depthead: [this.department.depthead,[Validators.required, Validators.required]]
    });	
  
  }
  // convenience getter for easy access to form fields
get f() {
  return this.departmentForm.controls
  }
 
 
 /*   getrequester() {
    return this.departmentService.getrequester()
               .subscribe(
                requester => {                  
                  this.requester = requester				  
                 }
                );
 }
*/
getDepartment(deptid) {
  return this.departmentService.getDepartment(deptid)
             .subscribe(
              department => {              
                this.department = department              
               }
              );
}

//below function is to restrict special character in input field
omit_special_char(e) {
  var k;
  document.all ? k = e.keyCode : k = e.which;
  return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
}

}
